import { render, staticRenderFns } from "./FormInputEventHoldType.vue?vue&type=template&id=2a0df7ad&scoped=true&lang=pug"
import script from "./FormInputEventHoldType.vue?vue&type=script&lang=ts"
export * from "./FormInputEventHoldType.vue?vue&type=script&lang=ts"
import style0 from "./FormInputEventHoldType.vue?vue&type=style&index=0&id=2a0df7ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0df7ad",
  null
  
)

export default component.exports